/* ===========================================
   Empaque Swipe - Sin Hammer.js
   Touch nativo con axis-lock Safari-proof
   =========================================== */

(() => {
    let pantallaActual = 1;
    const UMBRAL_SWIPE = 50;
    const UMBRAL_AXIS_LOCK = 5;

    // Función para mostrar pantalla específica
    const mostrarPantalla = (numeroPantalla) => {
        // Ocultar todas las pantallas
        document.querySelectorAll('.pantalla').forEach(pantalla => {
            pantalla.classList.remove('visible');
            pantalla.style.display = 'none';
        });

        // Mostrar pantalla seleccionada
        const pantallaDestino = document.getElementById(`empaque-pantalla0${numeroPantalla}`);
        if (pantallaDestino) {
            pantallaDestino.style.display = 'block';
            setTimeout(() => pantallaDestino.classList.add('visible'), 10);
        }

        // Actualizar botones de navegación
        const botonAtras = document.querySelector('.boton__empaque.atras');
        const botonAdelante = document.querySelector('.boton__empaque.adelante');

        if (botonAtras) {
            botonAtras.style.display = numeroPantalla < 2 ? 'none' : 'flex';
        }

        if (botonAdelante) {
            botonAdelante.style.display = numeroPantalla > 2 ? 'none' : 'flex';
        }

        // Actualizar indicadores
        document.querySelectorAll('.indicador__carrusel .circulo').forEach((circulo, indice) => {
            circulo.classList.toggle('activo', indice === numeroPantalla - 1);
        });
    };

    // Funciones públicas de navegación
    window.empaqueAdelante = () => {
        if (pantallaActual < 3) {
            pantallaActual++;
            mostrarPantalla(pantallaActual);
        }
    };

    window.empaqueAtras = () => {
        if (pantallaActual > 1) {
            pantallaActual--;
            mostrarPantalla(pantallaActual);
        }
    };

    // Inicializar después de un breve delay
    setTimeout(() => {
        // Mostrar pantalla inicial
        mostrarPantalla(pantallaActual);

        // Configurar hotspots (botones de etiqueta, reciclaje, etc.)
        const hotspots = [
            ['#boton-etiqueta', '#pantalla-etiqueta'],
            ['#boton-reciclaje', '#pantalla-reciclaje'],
            ['#boton-interior', '#pantalla-interior'],
            ['#boton-carton', '#pantalla-carton'],
            ['#boton-sello', '#pantalla-sello']
        ];

        hotspots.forEach(([selectorBoton, selectorPantalla]) => {
            const boton = document.querySelector(selectorBoton);
            const pantalla = document.querySelector(selectorPantalla);

            if (boton && pantalla) {
                // Abrir pantalla overlay
                boton.onclick = () => {
                    pantalla.classList.remove('animada-out');
                    pantalla.classList.add('animada-in');
                    setTimeout(() => pantalla.style.display = 'block', 250);
                };

                // Cerrar pantalla overlay
                pantalla.onclick = () => {
                    pantalla.classList.remove('animada-in');
                    pantalla.classList.add('animada-out');
                    setTimeout(() => {
                        pantalla.style.display = 'none';
                        pantalla.classList.remove('animada-out');
                    }, 250);
                };
            }
        });

        // ==========================================
        // SWIPE GESTURES - Reemplazo de Hammer.js
        // ==========================================
        const wrapper = document.querySelector('.empaque__wrapper');

        if (wrapper) {
            let touch = {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                deltaX: 0,
                deltaY: 0,
                direccion: null,
                activo: false
            };

            let scrollPosicionInicial = 0;

            function resetTouch() {
                touch.startX = 0;
                touch.startY = 0;
                touch.currentX = 0;
                touch.currentY = 0;
                touch.deltaX = 0;
                touch.deltaY = 0;
                touch.direccion = null;
                touch.activo = false;
            }

            // TOUCHSTART
            wrapper.addEventListener('touchstart', (e) => {
                scrollPosicionInicial = window.scrollY || window.pageYOffset;

                const t = e.touches[0];
                touch.startX = t.clientX;
                touch.startY = t.clientY;
                touch.currentX = t.clientX;
                touch.currentY = t.clientY;
                touch.direccion = null;
                touch.activo = true;
            }, { passive: true });

            // TOUCHMOVE
            wrapper.addEventListener('touchmove', (e) => {
                if (!touch.activo) return;

                const t = e.touches[0];
                touch.currentX = t.clientX;
                touch.currentY = t.clientY;
                touch.deltaX = touch.currentX - touch.startX;
                touch.deltaY = touch.currentY - touch.startY;

                const absDeltaX = Math.abs(touch.deltaX);
                const absDeltaY = Math.abs(touch.deltaY);

                // Decidir dirección (axis-lock)
                if (touch.direccion === null && (absDeltaX >= UMBRAL_AXIS_LOCK || absDeltaY >= UMBRAL_AXIS_LOCK)) {
                    if (absDeltaX > absDeltaY * 2) {
                        touch.direccion = 'horizontal';
                    } else if (absDeltaY > absDeltaX * 2) {
                        touch.direccion = 'vertical';
                    } else {
                        touch.direccion = 'vertical'; // Default a vertical para no romper scroll
                    }
                }

                // Si es horizontal, prevenir scroll
                if (touch.direccion === 'horizontal') {
                    if (e.cancelable) {
                        e.preventDefault();
                    }
                    window.scrollTo(window.scrollX, scrollPosicionInicial);
                }
            }, { passive: false });

            // TOUCHEND
            wrapper.addEventListener('touchend', () => {
                if (!touch.activo) return;

                // Solo procesar si fue un gesto horizontal
                if (touch.direccion === 'horizontal') {
                    const absDeltaX = Math.abs(touch.deltaX);
                    const absDeltaY = Math.abs(touch.deltaY);

                    // Verificar que cumple umbral y es más horizontal que vertical
                    if (absDeltaX > UMBRAL_SWIPE && absDeltaX > absDeltaY) {
                        if (touch.deltaX < 0) {
                            // Swipe izquierda → adelante
                            window.empaqueAdelante();
                        } else {
                            // Swipe derecha → atrás
                            window.empaqueAtras();
                        }
                    }
                }

                resetTouch();
            }, { passive: true });

            // TOUCHCANCEL
            wrapper.addEventListener('touchcancel', () => {
                resetTouch();
            }, { passive: true });
        }
    }, 10);
})();